"use strict";

module.exports = [
  "get", "put", "post", "delete", "options", "head", "patch"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/swagger-methods/lib/index.js
// module id = Y/EV
// module chunks = 0